import API from "./restAPI";
import { AxiosResponse } from "axios";

let config = require("../configuration.json");

export function apiImportReceipts(formData: any): Promise<AxiosResponse> {
  return API.post(`${config.serverUrl}/api/importreceiptsfromcsv`, formData);
}

export function apiImportReceiptsStatus(jobId:string,delay:number):Promise<AxiosResponse>{
    return API.get(`${config.serverUrl}/api/importStatus/${jobId}/${delay}`);
}